import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Contractor } from '@/types/Contractors'
import { getCurrentContractor } from '@/api/contractors'
import { useRouter } from 'vue-router'

export const useContractorStore = defineStore('contractor', () => {
  const contractor = ref<Contractor>({
    id: '',
    name: '',
    status: '',
    contactNumbers: [],
  })

  async function getContractor() {
    const result = await getCurrentContractor()
    if (!result) {
      useRouter().push({ name: 'signinError' })
      return
    }
    contractor.value = result
  }
  getContractor()

  return { contractor }
})
